export interface CarouselStylePreset {
  id: string;
  layoutVariant: string;
  fonts: {
    headline: string;
    body: string;
  };
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    highlightEnd: string;
  };
  assets: {
    frontLogo: string;
    gradient: string;
  };
  headline: {
    minFontSize: number;
    maxFontSize: number;
    fontWeight: number;
    lineHeightRatio: number;
    wordGap: number;
    paddingBottom: number;
  };
  explanation: {
    minFontSize: number;
    maxFontSize: number;
    lineHeightRatio: number;
    fontWeight: number;
  };
  layout: {
    sidePadding: number;
    logoWidth: number;
    swipeY: number;
  };
  features: {
    useGradientMask: boolean;
    showDecorativeLines: boolean;
  };
  effects: {
    highlightIntensity: number;
    highlightTextureStrength: number;
    bottomOverlayStrength: number;
  };
}

export const WEIRDPHYSICS_PREVIEW_FONTS = {
  headline: 'GenericCarouselImpact',
  body: 'GenericCarouselInterItalic',
};

export const weirdphysicsPreset: CarouselStylePreset = {
  id: 'weirdphysics',
  layoutVariant: 'image-led',
  fonts: WEIRDPHYSICS_PREVIEW_FONTS,
  colors: {
    primary: '#FFFFFF',
    secondary: '#E8E8E8',
    accent: '#79C9FF',
    highlightEnd: '#EAF8FF',
  },
  assets: {
    frontLogo: '/remotion/weirdphysics/Logo_small2.png',
    gradient: '/remotion/weirdphysics/GradientSaturated.png',
  },
  headline: {
    minFontSize: 70,
    maxFontSize: 120,
    fontWeight: 400,
    lineHeightRatio: 1,
    wordGap: 25,
    paddingBottom: 50,
  },
  explanation: {
    minFontSize: 34,
    maxFontSize: 48,
    lineHeightRatio: 1,
    fontWeight: 400,
  },
  layout: {
    sidePadding: 50,
    logoWidth: 64,
    swipeY: 620,
  },
  features: {
    useGradientMask: true,
    showDecorativeLines: true,
  },
  effects: {
    highlightIntensity: 1.16,
    highlightTextureStrength: 1,
    bottomOverlayStrength: 1,
  },
};

export const getCarouselPreset = (_brandingTag?: string): CarouselStylePreset => weirdphysicsPreset;

export const publicAssetUrl = (assetPath: string): string => {
  if (/^(https?:|blob:|data:)/i.test(assetPath)) return assetPath;
  const base = process.env.PUBLIC_URL || '';
  return `${base}${assetPath.startsWith('/') ? assetPath : `/${assetPath}`}`;
};
